import React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

const Sticker = styled(Paper)(({ theme }) => ({
  position: "relative",
  padding: theme.spacing(2),
  backgroundColor: "#fff",
  border: "1px solid #333",
  borderRadius: "5px",
  marginBottom: theme.spacing(0),
  overflow: "hidden",
}));

const DateText = styled(Typography)(({ theme }) => ({
  fontSize: "0.8rem",
  color: "#555",
  marginBottom: theme.spacing(1),
}));

const MessageText = styled(Typography)(({ theme }) => ({
  fontSize: "0.9rem",
  color: "#333",
}));

const StickerCard = ({ date, text }) => (
  <Sticker elevation={3}>
    <DateText variant="subtitle1">{date}</DateText>
    <MessageText variant="body2">{text}</MessageText>
  </Sticker>
);

export default StickerCard;
